import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';

import { NS } from '@/constants';
import { ProductModel } from '@/models';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

const ProductBonusDesktop = dynamic(() => import('@/components/product/ProductBonusDesktop'));
ProductBonusDesktop.displayName = 'ProductBonusDesktop';
const ProductBonusMobile = dynamic(() => import('@/components/product/ProductBonusMobile'));
ProductBonusMobile.displayName = 'ProductBonusMobile';

type Props = {
  product: ProductModel;
  itemImg: string;
  scrollToRatings: () => void;
};

const ProductBonus = ({ product, itemImg, scrollToRatings }: Props) => {
  const { t } = useTranslation(NS.PRODUCT);
  const isMobile = useScreenSizeContext().isMobile;

  return !isMobile ? (
    <ProductBonusDesktop product={product} itemImg={itemImg} scrollToRatings={scrollToRatings} t={t} />
  ) : (
    <ProductBonusMobile product={product} itemImg={itemImg} t={t} />
  );
};

export default ProductBonus;
